<form [formGroup]="iForm" name="iForm" (ngSubmit)="submit()" class="field-sm">
    <div class="row">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Date Of Birth</mat-label>
                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker" (click)="picker.open()" formControlName="birthDate" name="birthDate" required autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="f.birthDate.errors?.required && f.birthDate.touched">
                    Date Of Birth is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Given Name</mat-label>
                <input matInput placeholder="Given Name" formControlName="givenName" autocomplete="off" required>
                <mat-error *ngIf="f.givenName.errors?.required && f.givenName.touched">
                    Given Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Middle Name</mat-label>
                <input matInput placeholder="Middle Name" formControlName="middleName" autocomplete="off">
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Family Name</mat-label>
                <input matInput placeholder="Family Name" formControlName="familyName" autocomplete="off" required>
                <mat-error *ngIf="f.familyName.errors?.required && f.familyName.touched">
                    Family Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Stock Number</mat-label>
                <input matInput placeholder="Stock Number" formControlName="stockNumber" autocomplete="off" required>
                <mat-error *ngIf="f.stockNumber.errors?.required && f.stockNumber.touched">
                    Stock Number is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Acquisition Date</mat-label>
                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker2" (click)="picker2.open()" formControlName="acquisitionDate" name="acquisitionDate" required autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="f.acquisitionDate.errors?.required && f.acquisitionDate.touched">
                    Acquisition Date is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-12 text-center">
            <button class="btn btn-success btn-sm bold" type="submit" [disabled]="iForm.invalid">
                Verify
            </button>
        </div>

    </div>
</form>